"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Filter = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@mui/material/styles");

var _reactI18next = require("react-i18next");

var _Unstable_Grid = _interopRequireDefault(require("@mui/material/Unstable_Grid2"));

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));

var _InputLabel = _interopRequireDefault(require("@mui/material/InputLabel"));

var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));

var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));

var _Select = _interopRequireDefault(require("@mui/material/Select"));

var _Typography = _interopRequireDefault(require("@mui/material/Typography"));

var _Paper = _interopRequireDefault(require("@mui/material/Paper"));

var _Toolbar = _interopRequireDefault(require("@mui/material/Toolbar"));

var _SpeedDial = _interopRequireDefault(require("@mui/material/SpeedDial"));

var _SpeedDialIcon = _interopRequireDefault(require("@mui/material/SpeedDialIcon"));

var _SpeedDialAction = _interopRequireDefault(require("@mui/material/SpeedDialAction"));

var _FileCopyOutlined = _interopRequireDefault(require("@mui/icons-material/FileCopyOutlined"));

var _Box = _interopRequireDefault(require("@mui/material/Box"));

var _FilterAlt = _interopRequireDefault(require("@mui/icons-material/FilterAlt"));

var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon"));

var _Check = _interopRequireDefault(require("@mui/icons-material/Check"));

var _Menu = _interopRequireDefault(require("@mui/material/Menu"));

var _NavigateNext = _interopRequireDefault(require("@mui/icons-material/NavigateNext"));

var _NavigateBefore = _interopRequireDefault(require("@mui/icons-material/NavigateBefore"));

var boxStyle = {
  position: 'absolute',
  top: 100,
  right: '8px'
};

var Filter = function Filter(_ref) {
  var title = _ref.title,
      view = _ref.view,
      onChange = _ref.onChange,
      onNext = _ref.onNext,
      onPrevious = _ref.onPrevious;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var open = Boolean(anchorEl);

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose(view) {
    setAnchorEl(null);
  };

  var theme = (0, _styles.useTheme)();

  var _useState3 = (0, _react.useState)(7),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      dateRange = _useState4[0],
      setDateRange = _useState4[1];

  return /*#__PURE__*/_react.default.createElement(_Paper.default, {
    sx: {
      pl: '8px'
    }
  }, /*#__PURE__*/_react.default.createElement(_Unstable_Grid.default, {
    container: true,
    alignItems: "center",
    justifyContent: "space-between",
    sx: {
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_Unstable_Grid.default, {
    md: 10,
    flex: "1"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "subtitle1",
    sx: {
      color: theme.palette.info.main
    }
  }, " ", title, " ")), /*#__PURE__*/_react.default.createElement(_Unstable_Grid.default, {
    md: 1,
    sx: {
      display: 'flex'
    },
    flex: "1",
    justifyContent: "flex-end",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    size: "small",
    "aria-label": t('navigate before'),
    color: "info",
    onClick: onPrevious
  }, /*#__PURE__*/_react.default.createElement(_NavigateBefore.default, null)), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    size: "small",
    "aria-label": t('navigate next'),
    color: "info",
    onClick: onNext
  }, /*#__PURE__*/_react.default.createElement(_NavigateNext.default, null)), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    size: "small",
    color: "info",
    "aria-label": t('change view'),
    "aria-controls": "filter-menu",
    "aria-haspopup": "true",
    onClick: handleClick,
    sx: {
      pr: '8px',
      pt: 0,
      pb: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_FilterAlt.default, null)), /*#__PURE__*/_react.default.createElement(_Menu.default, {
    id: "filter-menu",
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleClose,
    MenuListProps: {
      'aria-labelledby': 'basic-button'
    }
  }, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    onClick: function onClick() {
      onChange('default');
      setAnchorEl(null);
    }
  }, view === 'default' && /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, null, /*#__PURE__*/_react.default.createElement(_Check.default, null)), t('default')), /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    onClick: function onClick() {
      onChange('week');
      setAnchorEl(null);
    }
  }, view === 'week' && /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, null, /*#__PURE__*/_react.default.createElement(_Check.default, null)), t('week')), /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    onClick: function onClick() {
      onChange('forthnight');
      setAnchorEl(null);
    }
  }, view === 'forthnight' && /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, null, /*#__PURE__*/_react.default.createElement(_Check.default, null)), t('forthnight')), /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    onClick: function onClick() {
      onChange('month');
      setAnchorEl(null);
    }
  }, view === 'month' && /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, null, /*#__PURE__*/_react.default.createElement(_Check.default, null)), t('month'))))));
}; // NOTE: Do interpolation based i18n


exports.Filter = Filter;